'use es6';

import { bindAll } from 'underscore';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { List, Map as ImmutableMap } from 'immutable';
import { EERIE, OLAF, OZ_DARK } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UIImage from 'UIComponents/image/UIImage';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import copyImage from 'bender-url!page-editor-ui/img/mab/copy.gif';
import ctaImage from 'bender-url!page-editor-ui/img/mab/cta.gif';
import mediaImage from 'bender-url!page-editor-ui/img/mab/media.gif';
import layoutImage from 'bender-url!page-editor-ui/img/mab/layout.gif';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TABS = List.of('cta', 'copy', 'media', 'layout');
const IMAGES = ImmutableMap({
  copy: copyImage,
  cta: ctaImage,
  layout: layoutImage,
  media: mediaImage
});
const MORE_INFO_LINKS = ImmutableMap({
  copy: 'https://blog.hubspot.com/marketing/write-compelling-copy-tips',
  cta: 'https://knowledge.hubspot.com/cta-user-guide-v2/call-to-action-best-practices',
  layout: 'https://blog.hubspot.com/marketing/write-compelling-copy-tips',
  media: 'https://blog.hubspot.com/marketing/stock-photography-authentic-imagery'
});
const BULLET_POINTS = ImmutableMap({
  copy: List.of('clearAndCompelling', 'helpful', 'organized'),
  cta: List.of('easyToSpot', 'actionOriented', 'easyToUnderstand'),
  layout: List.of('valueFocused', 'logical', 'uncluttered'),
  media: List.of('highQuality', 'authentic', 'optimized')
});
const langKey = suffix => `components.bestPracticesPopover.${suffix}`;
export default class BestPracticesPopover extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSkip = () => this.setState({
      openInitialPopover: false
    });
    this.handleShowMeHow = () => this.setState({
      openInitialPopover: false,
      openTips: true
    });
    this.handleOpenTips = () => this.setState({
      openTips: true
    });
    this.handleCloseTips = () => this.setState({
      openTips: false
    });
    this.handleToggleTips = () => this.setState(({
      openTips
    }) => ({
      openTips: !openTips
    }));
    this.renderTab = key => /*#__PURE__*/_jsxs(UITab, {
      tabId: key,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey(`${key}.title`)
      }),
      children: [/*#__PURE__*/_jsx("div", {
        className: "p-y-8 text-center",
        children: /*#__PURE__*/_jsx(UIImage, {
          responsive: false,
          src: IMAGES.get(key),
          width: 200
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        className: "display-block",
        message: langKey(`${key}.body`)
      }), /*#__PURE__*/_jsx(UIList, {
        childClassName: "p-y-1",
        className: "p-y-2 p-x-0",
        children: BULLET_POINTS.get(key).map(msgKey => `${key}.list.${msgKey}`).map(langKey).map(this.renderListItem)
      }), /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: MORE_INFO_LINKS.get(key),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey(`${key}.link`)
        })
      })]
    }, key);
    bindAll(this, 'handleSkip', 'handleShowMeHow', 'renderTab');
    this.state = {
      openInitialPopover: props.showInitialPopover,
      openTips: false
    };
  }
  renderListItem(message) {
    return /*#__PURE__*/_jsx(UIMediaObject, {
      itemLeft: /*#__PURE__*/_jsx(UIIconCircle, {
        backgroundColor: OZ_DARK,
        color: OLAF,
        name: "success",
        size: 7
      }),
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })
    }, message);
  }
  renderIcon() {
    return /*#__PURE__*/_jsx(UIIcon, {
      className: "pointer",
      color: EERIE,
      onClick: this.handleToggleTips,
      name: "info"
    });
  }
  renderInitialPopover() {
    const {
      mabMetric,
      test
    } = this.props;
    const bodyLangKey = test === 'ab' ? 'initialPopover.body.ab' : `initialPopover.body.${test}.${mabMetric}`;
    return /*#__PURE__*/_jsx(UIPopover, {
      content: {
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey(bodyLangKey)
        }),
        footer: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            onClick: this.handleShowMeHow,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey('initialPopover.buttons.confirm')
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            onClick: this.handleSkip,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey('initialPopover.buttons.cancel')
            })
          })]
        }),
        header: /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('initialPopover.header')
          })
        })
      },
      open: this.state.openInitialPopover,
      width: 360,
      placement: "bottom right",
      use: "shepherd",
      children: this.renderIcon()
    });
  }
  renderPopover() {
    return /*#__PURE__*/_jsx(UIPopover, {
      content: {
        body: /*#__PURE__*/_jsx(UITabs, {
          className: "text-start",
          defaultSelected: "cta",
          fill: true,
          panelClassName: "p-x-0 p-bottom-0",
          children: TABS.map(this.renderTab)
        }),
        header: /*#__PURE__*/_jsxs("h3", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('headingText')
          }), /*#__PURE__*/_jsx(UICloseButton, {
            color: EERIE,
            onClick: this.handleCloseTips,
            size: "md"
          })]
        })
      },
      className: "text-center best-practices",
      closeOnOutsideClick: true,
      onOpenChange: this.handleCloseTips,
      open: this.state.openTips,
      placement: "bottom right",
      use: "longform",
      width: 450,
      children: this.renderIcon()
    });
  }
  render() {
    if (this.state.openInitialPopover) {
      return this.renderInitialPopover();
    }
    return this.renderPopover();
  }
}
BestPracticesPopover.propTypes = {
  mabMetric: PropTypes.string,
  showInitialPopover: PropTypes.bool,
  test: PropTypes.oneOf(['ab', 'mab'])
};